import { render, staticRenderFns } from "./OurValues.vue?vue&type=template&id=5578f587&"
import script from "./OurValues.vue?vue&type=script&lang=js&"
export * from "./OurValues.vue?vue&type=script&lang=js&"
import style0 from "./OurValues.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports